import { registerItemType } from '../../core/registry/itemTypes';
import { PASSWORD_TYPE } from './model/types';

// Enregistrement léger, chargé avec la coque : Notes résout ainsi un mot de passe lié (« Mot de passe », icône clé)
// même si le code de l'écran Vault n'a pas encore été chargé.
registerItemType({ type: PASSWORD_TYPE, service: 'Vault', typeLabel: 'Mot de passe', icon: 'key' });
